import React, { useState } from 'react';
import { Save, RotateCcw } from 'lucide-react';
import { DEF_PARAMS } from './calendarLogic';

const num = 'w-20 px-2 py-1.5 text-sm font-mono text-right border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-200';

export const ParametrosTab = ({ params, onSave }) => {
  const [P, setP] = useState(() => JSON.parse(JSON.stringify(params)));
  const [sure, setSure] = useState(false);
  const ed = (t, fn) => { const c = JSON.parse(JSON.stringify(P)); fn(c[t]); setP(c); };
  const v = (e) => +e.target.value || 1;
  const reset = () => { if (sure) { setP(JSON.parse(JSON.stringify(DEF_PARAMS))); setSure(false); } else { setSure(true); setTimeout(() => setSure(false), 3500); } };
  return (
    <div data-testid="tab-content-parametros">
      <p className="text-sm text-slate-500 mb-4">Cambia los días hábiles de cada paso. Al guardar, todos los pedidos se recalculan en todos los PCs.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {Object.keys(P).map((t) => (
          <div key={t} data-testid={`param-card-${t}`} className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-bold text-slate-900">{P[t].n}</h3>
              <label className="flex items-center gap-2 text-xs font-semibold text-slate-500">Entrega en
                <input type="number" min="1" data-testid={`param-lim-${t}`} className={num} value={P[t].lim} onChange={(e) => ed(t, (x) => { x.lim = v(e); })} /> días hábiles
              </label>
            </div>
            <div className="divide-y divide-slate-100">
              {P[t].s.map((s, i) => (
                <div key={i} className="flex items-center gap-2 py-2 text-sm">
                  <span className="flex-1 text-slate-700">{s[0]}</span>
                  {s.length === 3 ? <span className="text-xs text-slate-400">cada</span> : null}
                  <input type="number" min="1" data-testid={`param-${t}-${i}-a`} className={num} value={s[1]} onChange={(e) => ed(t, (x) => { x.s[i][1] = v(e); })} />
                  {s.length === 3 ? <><span className="text-xs text-slate-400">{P[t].u} →</span><input type="number" min="1" data-testid={`param-${t}-${i}-b`} className={num} value={s[2]} onChange={(e) => ed(t, (x) => { x.s[i][2] = v(e); })} /></> : null}
                  <span className="text-xs text-slate-400 w-8">días</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 mt-5">
        <button data-testid="btn-guardar-parametros" onClick={() => onSave(P)} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors"><Save size={16} /> Guardar parámetros</button>
        <button data-testid="btn-restablecer-parametros" onClick={reset} className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold transition-colors ${sure ? 'bg-red-600 text-white hover:bg-red-700' : 'text-red-600 hover:bg-red-50'}`}><RotateCcw size={16} /> {sure ? '¿Seguro? Toca otra vez' : 'Restaurar valores iniciales'}</button>
      </div>
    </div>
  );
};
